import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import ServiceList from '~/widget/components/ServiceList';
import useCopy from '~/widget/hooks/useCopy';
import usePathPrefix from '~/widget/hooks/usePathPrefix';
import useWidgetContext from '~/widget/hooks/useWidgetContext';
import useTracking from '~/widget/hooks/useTracking';
import getUserId from '~/widget/utils/getUserId';
import copyTextToClipboard from '~/widget/components/CopyDeeplink/utils/copyTextToClipboard';

const StandaloneLanding: React.FC = ({}) => {
  const context = useWidgetContext();
  const pathPrefix = usePathPrefix();
  const { serviceList } = useCopy();
  const doTrack = useTracking();
  const userId = getUserId();
  const [copied, setCopied] = useState(false);

  if (
    window?.__DH_CONFIG?.accountId ===
    'a---e48cad50-7fa1-4eb0-af06-c11d0d80e05a'
  ) {
    const subject = encodeURIComponent('Widget User ID');
    const body = encodeURIComponent(`User ID: ${userId}`);
    const mailtoLink = `mailto:philipp@bndl.nl?subject=${subject}&body=${body}`;

    const handleCopy = () => {
      copyTextToClipboard(userId).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    };

    return (
      <div style={{ padding: '20px' }}>
        This is user user id: {userId}
        <br />
        <button onClick={handleCopy} type="button">
          {copied ? '✓ Copied!' : 'Copy User ID'}
        </button>
        <br />
        <br />
        Make Philipp super happy by sending him this user id (discord works as
        well) ❤️
        <br />
        <br />
        <a
          href={mailtoLink}
          style={{
            textDecoration: 'underline',
            border: '1px solid #000',
            padding: '10px',
            borderRadius: '5px',
          }}
        >
          Email it directly
        </a>
      </div>
    );
  }

  useEffect(() => {
    doTrack({ name: 'sap_app_list_loaded' });
  }, [doTrack]);

  return (
    <Main>
      <Helmet>
        <title>App Overzicht</title>
      </Helmet>
      <ServiceList
        items={context.apps}
        header={serviceList.apps}
        basePath={`${pathPrefix}/apps`}
        dataTestId="landing-service-list"
        includeHighlighted={true}
      />
      {/* Here's the place for the CTA component when we know what should be in there */}
    </Main>
  );
};

const Main = styled.main``;

export default StandaloneLanding;
